<!--  ispay  ： 0 收费  1免费-->
<template>
    <div class="page-film-detail new" v-if="isShow">
        <!--<div class="film-top-info" :style="{'background-image': 'url(' + section.backgroundImage + ')'}">-->
        <div class="film-top-info">
            <div class="mask-bg">
                <div class="common-wrap">
                    <div class="video-info clearfix">
                        <!--<div v-if="!isLogin || (!section.buy && section.isPay == 0 && remainDuration <= 0) || !ccsrc" class="video-wrap" :style="{'background-image': 'url(' + section.sectionThumbnail + ')'}">
                          <i class="play-btn" v-if="!isLogin" v-on:click="toPlay(1)"></i>
                          <i class="play-btn" v-else-if="!ccsrc" v-on:click="toPlay(3)"></i>
                          <i class="play-btn" v-else v-on:click="toPlay(2)"></i>
                        </div>--> <!--!clipsCCSrc-->
                        <!--  按钮显示 : （没买 且 收费 且 没有福利时间 且 有片花视频） 或 (没有视频 且 )  -->
                        <div v-if="(!section.buy && section.isPay == 0 && remainDuration <= 0 && !clipsCCSrc) || !ccsrc " class="video-wrap" :style="{'background-image': 'url(' + section.sectionThumbnail + ')'}">
                            <i class="play-btn" v-if="!ccsrc" v-on:click="toPlay(3)"></i>
                            <i class="play-btn" v-else v-on:click="toPlay(2)"></i>
                            <marquee behavior="" direction="" loop="" class="times-tip" style="top: 0;bottom: unset;">
                              亲爱的用户，我们特此通知您，从50集合辑包开始，《中华上下五千年》将不再以合集包的形式发售，欢迎大家续订以朝代分集的专辑包。感谢理解和支持！
                            </marquee>
                        </div>



                        <div v-else class="video-wrap">
                            <!-- playType: 1剧集播放
                                  playResId: 播放资源ID
                                  playUserId :观看用户ID
                                  sCutTime:是否减去观影时间
                            -->
                            <!-- 没买且收费   扣时间-->
                            <cc-video
                                    ref="ccVideo"
                                    :ccsrc="ccsrc"
                                    :ccPic="ccPic"
                                    :playType="1"
                                    :playUserId ='loginUserId'
                                    :playResName="section.sectionName"
                                    :playUserName="loginUserName"
                                    :playResId="section.id"
                                    :isCutTime=true
                                    v-if="isCCReload && isLogin && !section.buy && section.isPay ==0 && remainDuration > 0"
                            ></cc-video>
                            <!-- 没买且收费 且  没有免费时长 播放片花-->
                            <cc-video
                                    ref="ccVideo"
                                    :ccsrc="clipsCCSrc"
                                    :ccPic="clipsCCSrc"
                                    :playType="1"
                                    :playResId="section.id"
                                    :playResName="section.sectionName"
                                    :playUserName="loginUserName"
                                    :playUserId ='loginUserId'
                                    :isCutTime=false
                                    v-else-if="isCCReload && (!section.buy && section.isPay ==0 && clipsCCSrc && remainDuration <= 0)"
                            ></cc-video>
                            <!-- 买过或免费 可以播放 正式影片-->
                            <cc-video
                                    ref="ccVideo"
                                    :ccsrc="ccsrc"
                                    :ccPic="ccPic"
                                    :playType="1"
                                    :playResId="section.id"
                                    :playResName="section.sectionName"
                                    :playUserName="loginUserName"
                                    :playUserId ='loginUserId'
                                    :isCutTime=false
                                    v-else-if="isCCReload && (section.buy || section.isPay ==1)"
                            ></cc-video>


                            <transition name="tip-translate-top">
                                <div class="times-tip" style="top: 0;bottom: unset;" v-if="showTopTips">
                                    <marquee behavior="" direction="" >
                                      亲爱的用户，我们特此通知您，从50集合辑包开始，《中华上下五千年》将不再以合集包的形式发售，欢迎大家续订以朝代分集的专辑包。感谢理解和支持！                                    </marquee>
                                    <i class="el-icon-close tip-cloce-btn" @click="showTopTips = false"></i>
                                </div>
                            </transition>
                            <transition name="tip-translate">
                                <div class="times-tip" v-if="showTimeTips && showTimeTipsType == 1">
                                    <marquee behavior="" direction="" >
                                        温馨提示：您剩余免费观影时长<span>{{remainDuration}}</span>分钟
                                    </marquee>
                                    <i class="el-icon-close tip-cloce-btn" @click="showTimeTips = false"></i>
                                </div>
                                <div class="times-tip" v-if="showTimeTips && showTimeTipsType == 2">
                                    <marquee behavior="" direction="" >
                                        温馨提示：“亲爱的人人动画网用户，你好，您获得免费限时观看时长已用完，继续观看请付费购买或联系运营人员”
                                    </marquee>
                                    <i class="el-icon-close tip-cloce-btn" @click="showTimeTips = false"></i>
                                </div>
                            </transition>


                        </div>
                        <!--<div class="video-wrap" :style="{'background-image': 'url(' + require('@/assets/images/film_banner.jpg') + ')'}">
                          <i class="play-btn"></i>
                        </div> -->

                        <!--            <div v-else v-html="videoHtml" class="iframe-h"></div>-->

                        <div class="film-infoes">
                            <div class="film-tit">{{section.course.courseName}}</div>
                            <div class="film-color-view" :title="section.course.updateTips">{{section.course.updateTips}}</div>
                            <div class="film-color-view zhe" :title="section.course.specialOffers">{{section.course.specialOffers}}</div>
                            <div class="film-desc">
                                <p class="desc-tit">故事简介</p>
                                <p class="desc-cont">
                                    <over-words :words="section.course.courseIntroduction" :limit="40"></over-words>
                                </p>
                            </div>
                            <ul class="type-ji-select clearfix">
                                <li :class="showType=='all'?'active':''" v-on:click="changeShowList('all')">选集</li>
                                <li :class="showType=='my'?'active':''" v-on:click="changeShowList('my')">我购买的剧集</li>
                            </ul>
                            <ul class="ji-list clearfix" v-show="showType === 'all'">
                                <li
                                        v-for="(item, index) in showPage"
                                        :key="index"

                                        :class="{'active': index === currentPartAllIndex}"
                                        @click="selectTitlePage(index)"
                                >
                                    {{item}}
                                </li>
                            </ul>
                            <ul class="ji-list clearfix" v-show="showType === 'my'">
                                <li
                                        v-for="(item, index) in showPage"
                                        :key="index"

                                        :class="{'active': index === currentPartMyIndex}"
                                        @click="selectTitleMyPage(index)"
                                >
                                    {{item}}
                                </li>
                            </ul>
                            <ul class="ji-cont">

                                <vue-scroll :ops="scrollops">
                                    <div v-if="showType=='all' && currentPartAllIndex == 0 "><!--sectionName -->
                                        <li class="clearfix"  v-for="(sec, index) in seqZeroSectionList" :key="index" >
                                            <span class="ji-name black" v-if="sec.videoId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name" v-else >{{sec.sectionName}}</span>

                                            <span class="ji-buy ygm" v-if="sec.buy === true && sec.videoId" v-on:click="selectSec(sec.id,false)"><!--已购买-->观看</span>
                                            <span class="ji-buy " v-else-if="sec.buy === true && !sec.videoId" ><!--已购买-->更新中</span>
                                            <span class="ji-buy ygm" v-else-if="sec.isPay === 1" v-on:click="selectSec(sec.id,false)">免费</span>
                                            <span class="ji-buy" v-else-if="remainDuration >0" v-on:click="toSection(sec.id)">限时免费</span>
                                            <span class="ji-buy" v-else-if="!sec.videoId"  @click="selectHeji">预售</span><!--  v-on:click="this(sec.id)" -->
                                            <span class="ji-buy" v-else  @click="selectHeji">购买</span> <!-- v-on:click="buyOne(sec)" -->
                                        </li>
                                    </div>
                                    <div v-if="showType=='all'">


                                        <li class="clearfix"  v-for="(sec, index) in allList" :key="index" >

                                            <span class="ji-name blue" v-if="sec.videoId && sec.id == objId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name black" v-else-if="sec.videoId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name" v-else >{{sec.sectionName}}</span>

                                            <span class="ji-buy ygm" v-if="sec.buy === true && sec.videoId" v-on:click="selectSec(sec.id,false)"><!--已购买-->观看</span>
                                            <span class="ji-buy " v-else-if="sec.buy === true && !sec.videoId"><!--已购买-->更新中</span>
                                            <span class="ji-buy ygm" v-else-if="sec.isPay === 1" v-on:click="selectSec(sec.id,false)">免费</span>
                                            <span class="ji-buy" v-else-if="remainDuration >0 && sec.videoId" v-on:click="toSection(sec.id)">限时免费</span>
                                            <span class="ji-buy" v-else-if="!sec.videoId" @click="selectHeji">预售</span> <!-- v-on:click="buyOne(sec)" -->
                                            <span class="ji-buy" v-else  @click="selectHeji">购买</span><!-- v-on:click="buyOne(sec)" -->
                                        </li>
                                    </div>
                                    <!-- currentPartMyIndex -->
                                    <div v-if="showType=='my'  && currentPartMyIndex == 0">
                                        <li class="clearfix"  v-for="(sec, index) in mySeqZeroSectionList" :key="index" >
                                            <!--                    <router-link target="_self" :to="{path:'/filmdetail', query: {id:sec.id}}"  >-->
                                            <span class="ji-name blue" v-if="sec.videoId && sec.id == objId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name black" v-else-if="sec.videoId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name" v-else >{{sec.sectionName}}</span>

                                            <!--                    </router-link>-->
                                            <span class="ji-buy ygm" v-if="sec.isPay === 1" v-on:click="selectSec(sec.id,false)">免费</span>
                                            <span class="ji-buy " v-else-if="!sec.videoId" >更新中</span>
                                            <span class="ji-buy ygm" v-else v-on:click="selectSec(sec.id,false)">观看</span>
                                        </li>
                                    </div>
                                    <div v-if="showType=='my'">
                                        <li class="clearfix"  v-for="(sec, index) in myList" :key="index" >
                                            <!--                    <router-link target="_self" :to="{path:'/filmdetail', query: {id:sec.id}}"  >-->
                                            <span class="ji-name blue" v-if="sec.videoId && sec.id == objId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name black" v-else-if="sec.videoId" v-on:click="toSection(sec.id)" style="cursor:pointer">{{sec.sectionName}}</span>
                                            <span class="ji-name" v-else >{{sec.sectionName}}</span>

                                            <!--                    </router-link>-->
                                            <span class="ji-buy ygm" v-if="sec.isPay === 1" v-on:click="selectSec(sec.id,false)">免费</span>
                                            <span class="ji-buy " v-else-if="!sec.videoId" >更新中</span>
                                            <span class="ji-buy ygm" v-else v-on:click="selectSec(sec.id,false)">观看</span>
                                        </li>
                                    </div>
                                    <!--                <li class="clearfix">-->
                                    <!--                  <span class="ji-name">第1集：序幕第1集：序幕第1集：序幕第1集：序幕第1集：序幕第1集：序幕第1集：序幕第1集：序幕</span>-->
                                    <!--                  <span class="ji-buy">购买单集</span>-->
                                    <!--                </li>-->
                                    <!--                <li class="clearfix">-->
                                    <!--                  <span class="ji-name">第2集：盘古开天</span>-->
                                    <!--                  <span class="ji-buy ygm">已购买</span>-->
                                    <!--                </li>-->
                                    <!--                <li class="clearfix">-->
                                    <!--                  <span class="ji-name">第2集：盘古开天</span>-->
                                    <!--                  <span class="ji-buy ygm">免费</span>-->
                                    <!--                </li>-->
                                </vue-scroll>
                            </ul>

                            <div class="ytm-info">
                                <div class="buy-btns">

                                    <!--<el-popover
                                            width="300"
                                            trigger="hover"
                                            popper-class="yh-popo"
                                            :visible-arrow="false"
                                            placement="top-start"
                                    >
                                        <el-button slot="reference" type="danger" @click="selectJiEvent(1)">合集购买</el-button>
                                    </el-popover>-->
                                    <!--<el-popover
                                            width="300"
                                            trigger="hover"
                                            popper-class="yh-popo"
                                            :visible-arrow="false"
                                            placement="top-start"
                                    >

                                        <div class="yh-wrap">
                                            <div class="con">
                                                <span class="n-tit">优惠价</span>
                                                <span class="n-price">￥{{tenPrice}}</span>
                                                <span class="old-price">原价￥{{tenOldPrice}}</span>
                                            </div>
                                        </div>
                                        <el-button slot="reference" type="danger" @click="selectJiEvent(1)">购买10集</el-button>
                                    </el-popover>
                                    <el-popover
                                            width="300"
                                            trigger="hover"
                                            popper-class="yh-popo"
                                            :visible-arrow="false"
                                            placement="top-start"
                                    >
                                        <div class="yh-wrap">
                                            <div class="con">
                                                <span class="n-tit">优惠价</span>
                                                <span class="n-price">￥{{twityPrice}}</span>
                                                <span class="old-price">原价￥{{twityOldPrice}}</span>
                                            </div>
                                        </div>
                                        <el-button slot="reference" type="danger" @click="selectJiEvent(2)">购买20集</el-button>
                                    </el-popover>-->

                                    <el-button type="danger" @click="selectHeji">购买</el-button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <!-- 选择集数弹窗 -->
        <el-dialog
                title="选择集数"
                top="60px"
                :visible.sync="selectDialog"
                :width="$store.state.app.device === 'desktop' ? '700px' : '90%'"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <div class="dialog-select-ji">
                <ul class="buy-count-btns clearfix">
                    <li :class="{'active': part == 1}" @click="selectJiEvent(1)">购买10集</li>
                    <li :class="{'active': part == 2}" @click="selectJiEvent(2)">购买20集</li>
                    <li :class="{'active': part == 3}" @click="selectJiEvent(3)">购买30集</li>
                </ul>
                <ul class="simp-list clearfix">
                    <li
                            v-for="(item, index) in selectNotFreePager"
                            :key="index"
                            :class="{'active': index === currentPartIndex}"
                            @click="selectPage(index)"
                    >
                        {{item}}
                    </li>
                </ul>
                <div class="select-info clearfix">
                    <el-checkbox class="all-check"
                                 :indeterminate="isIndeterminate"
                                 v-model="checkAll"
                                 @change="handleCheckAllChange">当页全选</el-checkbox>
                    <div class="current-info">
                        已选<span :style="{'color': userCheckList.length == part * 10 ? '' : '#ff0000'}">{{userCheckList.length}}</span>/{{part * 10}}集
                        <span class="empty" @click="emptyFilm" v-if="userCheckList.length > 0">清空</span>
                    </div>
                </div>
                <div class="sleect-view clearfix">
                    <el-checkbox-group class="user-selec clearfix" v-model="userCheckList" @change="handleCheckedCitiesChange">
                        <ul class="clearfix">
                            <li
                                    v-for="item in filmList"
                                    :key="item.id"
                                    class="sele-item"
                                    :title="item.sectionName"
                            >

                                <el-checkbox
                                        :label="item.sectionName"
                                        :disabled="item.buy || item.isPay === 1 || (userCheckList.length  == 10 * part && userCheckList.indexOf(item.sectionName) ==-1)"
                                >
                                </el-checkbox>
                                <span v-if="item.buy" class="y-btn byd">已购买</span>
                                <span v-else-if="!item.videoId" class="y-btn">预售</span>

                            </li>
                        </ul>
                        <div class="has-buy-tip" v-show="pageHasBuyed">提示：本页有已购买剧集，请前往其他页选满{{part}}0集。</div>
                    </el-checkbox-group>
                    <ul class="show-view">
                        <vue-scroll :ops="scrollops">
                        <li
                                class="clearfix"
                                v-for="(item, index) in userCheckList"
                                :key="index"
                        >
                            <span class="tit">{{item}}</span>
                            <i class="el-icon-close del-btn" @click="delFilm(index)"></i>
                        </li>
                        </vue-scroll>
                    </ul>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <!--<el-button
          :disabled="userCheckList.length === part * 10 ? false : true"
          :type="userCheckList.length == part * 10 ? 'danger' : 'info'"
        >-->
          <div class="dialog-footer-count-infos" v-if="part == 1">{{10 * part}}集优惠价
            <span class="now">￥{{tenPrice}}</span>
            <span class="old">原价 ￥{{tenOldPrice}}</span>
          </div>
          <div class="dialog-footer-count-infos" v-else-if="part == 2">{{10 * part}}集优惠价
            <span class="now">￥{{twityPrice}}</span>
            <span class="old">原价 ￥{{twityOldPrice}}</span>
          </div>
          <div class="dialog-footer-count-infos" v-else>{{10 * part}}集优惠价
            <span class="now">￥{{thirtyPrice}}</span>
            <span class="old">原价 ￥{{thirtyOldPrice}}</span>
          </div>

          <el-button
                  :disabled="userCheckList.length === part * 10 ? false : true"
                  :type="userCheckList.length == part * 10 ? 'danger' : 'info'"
                  v-on:click="toPay()"
          >
          确 定
        </el-button>
      </span>
        </el-dialog>
        <!-- 观影提示 -->
        <!--<el-dialog
                    title="观影提示"
                    top="60px"
                    center
                    :visible.sync="showTimeTips"
                    :width="$store.state.app.device === 'desktop' ? '400px' : '90%'"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
            >
              <div class="log-tip">您当前拥有<span>{{remainDuration}}分钟</span>的免费观影时长。在观影时长内，您可以免费观看任意收费影片，直至观影时长消耗完毕。</div>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showTimeTips = false">确 定</el-button>
              </span>
            </el-dialog>-->

        <!-- 专辑购买弹窗 -->
        <el-dialog
            title="剧集购买"
            top="60px"
            center
            :visible.sync="hejiDialog"
            :width="$store.state.app.device === 'desktop' ? '700px' : '90%'"
        >
            <!-- <div class="heji-tip">专辑的实际价格不计算您已购买的剧集</div> -->
            <div class="film-tabs">
                <div
                    :class="['item', {active: index === filmTabIndex}]"
                    v-for="(item, index) in filmTabList"
                    @click="filmTabIndex = index"
                >
                    {{item}}
                </div>
            </div>
            <div class="juji-wrap">
                <f-heji1 v-if="filmTabIndex == '0'" v-for="(item, index) in hejiListByTypeTwo" :key="index" :item="item"></f-heji1>
                <f-heji2 v-if="filmTabIndex == '1'" v-for="(item, index) in hejiListByTypeOne" :key="index" :item="item"></f-heji2>
            </div>
        </el-dialog>


        <!-- 购买成功提示 -->
        <el-dialog
                title="购买成功"
                top="60px"
                center
                :visible.sync="buySucc"
                :width="$store.state.app.device === 'desktop' ? '400px' : '90%'"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <div class="log-tip">
                您可以扫描下方的太阳吗，或微信搜索小程序"人人动画放映厅"，使用微信小程序观看或分享影片。
                <img class="qr-code" :src="require('@/assets/images/user_avatar.jpg')" alt="">
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="buySucc = false">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 输入分享码 -->
        <el-dialog
                title="输入分享码"
                top="60px"
                center
                :show-close="false"
                :visible.sync="iptShareCode"
                :width="$store.state.app.device === 'desktop' ? '400px' : '90%'"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <div class="share-code-wrap">
                <el-input v-model="inputShareCode" placeholder="请输入分享码" />
                <p class="share-code-tip">输入“分享码”购买可享受9.8折优惠</p>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="buyForShare(1)">确 定</el-button>
        <el-button @click="buyForShare(2)">跳 过</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import vuescroll from 'vuescroll'
    import filmApi from "@/api/film";
    import userInfoApi from '@/api/userInfo'
    import CcVideo from '@@/pub/ccvideo/ccvideo'
    import OverWords from '@@/question/pub/overflow'
    import heji from '@@/pub/film/heji'
    import vcApi from '@/api/videocollection'

    export default {
        //mixins: [filmMixins],
        props: {},
        components: {
            'vue-scroll': vuescroll,CcVideo,OverWords,'f-heji1': heji,'f-heji2': heji
        },
        props:{
            secId: {
                required: true,
                type: Number
            },
        },
        data () {
            return {
                ccsrc:"", //cc视频
                clipsCCSrc:"", //片花 -cc视频
                ccPic:"",
                isCCReload:false,

                isShow:false,
                isLogin:false,
                loginUserId :0,
                loginUserName :'',

                mySectionList:[],
                allSectionList:[],
                notFreeSectionList:[],
                seqZeroSectionList:[],
                section:{},

                scrollops: {
                    vuescroll: {
                        wheelScrollDuration: 300
                    },
                    scrollPanel: {
                        scrollingX: false
                    },
                    bar: {
                        keepShow: true,
                        background: '#dedede'
                    }
                },
                rateVal: 9.2,
                myRateVal: 8,
                setRateVal: null,
                selectDialog: false,
                serverList: [],
                part: 1, // 10的几倍数为区间
                currentPartIndex: 0,
                userCheckList: [],
                checkAll: false,
                isIndeterminate: false,

                showPage:[],
                buyCount:0,
                currentPartAllIndex:0,
                currentPartMyIndex:0,
                showType:"all",

                orderDetail:{},
                orderList:[],
                //更新浏览数
                upViewParam:{
                    id:0,
                    previewTimes:0,
                    sectionThumbnail:'',
                    updateType:'1',
                },
                //添加评分
                upScoreParam:{
                    resourceType:1,//评分对象类型 1，课节
                    resourceId:0, //评分对象ID 课节ID
                    score:0,
                },
                //更新催更数
                upCuiGengParam:{
                    id:0,
                    urgedUpdateCount:0,
                    sectionThumbnail:'',
                    updateType:'2',
                },
                videoHtml:'',
                objId:0,
                isReload:true,
                isReloadScore:true,

                startParams:{
                    pageIndex:1,
                    pageSize:4,
                    orderType:'start',
                    courseId:0,
                },
                startData:[],

                isAutoStart:false,
                showMoreWords: false,
                showTopTips: true,
                showTimeTips: false, //剩余时长提示
                remainDuration:0,//是否有剩余时间
                buySucc: false,       //购买成功 太阳吗 提示
                iptShareCode: false, //分享码提示
                shareCode: '',
                shareCodeUserId: '',
                inputShareCode:'',

                showTimeTipsType:1, //剩余时长提示显示类型，1 倒计时 ，2 刚刚为零


                tenPrice:0,
                twityPrice:0,
                thirtyPrice:0,

                tenOldPrice:0,
                twityOldPrice:0,
                thirtyOldPrice:0,

                canCuiGeng:false,  //是否可以催更
                newSectionId:0,  //最新一节ID （含视频 --非预售）

                pageHasBuyed:false,

                hejiDialog: false,
                hejiList: [],
                hejiListByTypeOne: [],
                hejiListByTypeTwo: [],
                vcParam:{
                    status:2,
                },
                vcParam1:{
                    collectionType:1,
                    status:2,
                },
                vcParam2:{
                    collectionType:2,
                    status:2,
                },
                filmTabIndex: 0,
                filmTabList: ['专辑购买', '合集购买']
            }
        },


        computed: {
            //非免费列表
            filmList () {
                let this_ = this
                let filmList = this.notFreeSectionList.slice(this.currentPartIndex * 1 * 10, this.currentPartIndex * 1 * 10 + 1 * 10)
                this_.pageHasBuyed = false
                filmList.forEach( item =>{
                    if(item.buy){
                        this_.pageHasBuyed = true
                    }
                })
                return filmList;
            },
            //全部列表
            allList(){
                return this.allSectionList.slice(this.currentPartAllIndex  * 10, this.currentPartAllIndex * 10 +  10)
            },
            //我的列表
            myList(){
                return this.mySectionList.slice(this.currentPartMyIndex  * 10, this.currentPartMyIndex * 10 +  10)
            },

            // 已经购买的列表
            // buyList () {
            //   let buyL = []
            //   this.allSectionList.forEach(item => {
            //     if(item.buy === true || item.isPay === 1){
            //       buyL.push(item.sectionName)
            //     }
            //   })
            //   return buyL
            // },

            //拆分页码  --弹窗  根据part参数分为 每页10，20
            selectPager () {
                let listLength = this.allSectionList.length
                let part = this.part
                let forlen = Math.floor(listLength / (part * 10))
                let page = []
                if(listLength <= part * 10){
                    // 只输出 1 ~ <= 10
                    page.push(`第1~${listLength}集`)
                }else{
                    for(let i = 0;i < forlen;i++){
                        // 中间的循环体
                        page.push(`第${parseInt(i * part + '1')}~${(i + 1) * part}0集`)
                    }
                    if(String(listLength).slice(-1) === '1' && page.length * part * 10 + 1 === listLength){
                        // 最后的长度为 21 || 31 等个位数为1 时 则 只添加 第n集
                        page.push(`第${listLength}集`)
                    }else if (listLength % (10 * part) !== 0){
                        // 否则添加第 n1集 ~ 第 length集
                        page.push(`第${forlen * part}1~${listLength}集`)
                    }
                }
                return page
            },

            selectNotFreePager () {
                let listLength = this.notFreeSectionList.length
                let part = 1
                let forlen = Math.floor(listLength / (part * 10))
                let page = []
                if(listLength <= part * 10){
                    // 只输出 1 ~ <= 10
                    page.push(`第1~${listLength}集`)
                }else{
                    for(let i = 0;i < forlen;i++){
                        // 中间的循环体
                        page.push(`第${parseInt(i * part + '1')}~${(i + 1) * part}0集`)
                    }
                    if(String(listLength).slice(-1) === '1' && page.length * part * 10 + 1 === listLength){
                        // 最后的长度为 21 || 31 等个位数为1 时 则 只添加 第n集
                        page.push(`第${listLength}集`)
                    }else if (listLength % (10 * part) !== 0){
                        // 否则添加第 n1集 ~ 第 length集
                        page.push(`第${forlen * part}1~${listLength}集`)
                    }
                }
                return page
            }
        },

        mounted(){
            this.objId = this.secId
            if(this.global.isLogin) {
                this.loginUserId = this.global.userModel.id
                this.loginUserName = this.global.userModel.name
                this.isLogin = true
            }
            // filmApi.selectSec(this.secId).then( re=>{
            //     this.section  = re.response
            //     console.log("==========section========",this.section)
            //     this.initData(this.currentPartMyIndex,this.currentPartAllIndex)
            // })

            this.initData(this.currentPartMyIndex,this.currentPartAllIndex)
            vcApi.getVCList(this.vcParam1).then( reVc=>{
                console.log("reVc.vcParam1------",reVc.response)
                this.hejiList = reVc.response
                this.hejiListByTypeOne = reVc.response
            })
            vcApi.getVCList(this.vcParam2).then( reVc=>{
                console.log("reVc.vcParam2------",reVc.response)
                this.hejiList = reVc.response
                this.hejiListByTypeTwo = reVc.response
            })
        },
        methods: {
            toSection(secId){
                //this.secId = secId
                this.objId = secId
                this.initData(this.currentPartMyIndex,this.currentPartAllIndex)
                //this.$parent.reloadFilmPart(secId)

                //this.currentPartAllIndex = index
                //this.currentPartMyIndex = index
                /*if(this.showType == 'my'){
                    //window.location.href = '/filmdetail?id='+id+"&showType="+this.showType+"&mi="+this.currentPartMyIndex
                    filmApi.selectSec(secId).then( re=>{
                        this.section  = re.response
                        console.log("==========section========",this.section)
                        this.initData(this.currentPartMyIndex,this.currentPartAllIndex)
                    })
                }else {
                    //window.location.href = '/filmdetail?id='+id+"&showType="+this.showType+"&ai="+this.currentPartAllIndex
                    filmApi.selectSec(secId).then( re=>{
                        this.section  = re.response
                        console.log("==========section========",this.section)
                        this.initData(this.currentPartMyIndex,this.currentPartAllIndex)
                    })
                }*/


            },
            initData(currentPartMyIndex,currentPartAllIndex){
                let sharecode = this.$route.query.sharecode
                let showType =  this.$route.query.showType
                if(showType){
                    this.showType = showType
                }



                if(currentPartAllIndex){
                    this.currentPartAllIndex = currentPartAllIndex * 1
                }
                if(currentPartMyIndex){
                    this.currentPartMyIndex = currentPartMyIndex * 1
                }
                window.ccH5PlayerJsLoaded = true;
                window.on_CCH5player_ready = this.onPlayerReady;

                //是否打开浏览器第一次催更
                let cuigenged = this.getCookie("cuigenged")
                if(!cuigenged){
                    this.canCuiGeng = true
                }
                if(this.global.isLogin){
                    this.loginUserId = this.global.userModel.id
                    this.loginUserName= this.global.userModel.name
                    this.isLogin = true

                    const formData = new FormData() // 创建form对象
                    formData.append('userId', this.loginUserId)// 通过append向form对象添加数据
                    formData.append('minutes', 0)// 通过append向form对象添加数据

                    userInfoApi.subtractTimes(formData).then(re => {

                        //判断剩余 免费时长
                        this.remainDuration = re.response.remainDuration
                        //let showTiped =this.getCookie("showTiped")  && !showTiped
                        if(this.remainDuration > 0 ){
                            //this.setCookie('showTiped',1)
                            this.showTimeTips = true
                            setTimeout(()=>{
                                this.showTimeTips = false
                            },60000)
                        }
                    })
                    if(sharecode){
                        /* 根据分享码，获取对应用户ID*/
                        this.shareCode = sharecode
                        const formDataCode = new FormData() // 创建form对象
                        formDataCode.append('invitationCode', this.shareCode)// 通过append向form对象添加数据
                        userInfoApi.selectByInvitationCode(formDataCode).then(re => {
                            console.log("invitationCode===",re)
                            if(re.code == 1){
                                this.shareCode=re.response.invitationCode
                                this.shareCodeUserId=re.response.userId
                            }else{
                                this.shareCode=''
                                this.shareCodeUserId=''
                            }
                        })
                    }

                    this.selectSec(this.objId,false)
                }else{
                    this.selectSec(this.objId,false)
                }



            },
            NumberMul(arg1, arg2) {
                var m = 0;
                var s1 = arg1.toString();
                var s2 = arg2.toString();

                try {
                    if(s1.indexOf('.') >0){
                        m += s1.split(".")[1].length;
                    }
                } catch (e) {
                    console.log(e)
                }
                try {
                    if(s2.indexOf('.') >0){
                        m += s2.split(".")[1].length;
                    }
                } catch (e) {
                    console.log(e)
                }

                return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
            },
            //查询剧集信息 == 全部、我的
            selectSec(id,autoPaly){
                filmApi.selectSec(id).then( re =>{
                    this.section  = re.response

                    if(this.section.sectionThumbnail.indexOf("backImg1") >-1 ){
                        let jsonBackImg =  JSON.parse(this.section.sectionThumbnail)

                        this.section.sectionThumbnail = jsonBackImg.backImg1
                    }

                    this.allSectionList = re.response.sectionList //不包括排序 0的全部课节
                    this.seqZeroSectionList = re.response.sectionSeqZeroList //排序0的课节

                    this.mySectionList =re.response.sectionBuyList
                    this.notFreeSectionList = re.response.sectionNotFreeList

                    this.mySeqZeroSectionList =re.response.sectionBuyZeroList
                    this.mySeqZeroSectionList =re.response.sectionBuyZeroList

                    let n = 0
                    this.allSectionList.forEach(item =>{

                        if(item.videoId){
                            this.newSectionId = item.id
                        }

                        if(item.buy === true || item.isPay === 1){
                            n++
                        }
                    })
                    //console.log("=======================newSectionId",this.newSectionId)

                    this.seqZeroSectionList.forEach(item =>{
                        if(item.buy === true || item.isPay === 1){
                            n++
                        }
                    })
                    this.buyCount = n;

                    this.showPage = this.selectTitlePager(this.showType)


                    this.isShow = true
                    //this.setHtml(this.section)
                    this.isAutoStart = autoPaly
                    this.setCCDIV(this.section)


                    if(this.section.course.discountPrice !=null && this.section.course.discountPrice !=''  ){
                        let selTag =  JSON.parse(this.section.course.discountPrice)
                        selTag.forEach(priceItem => {

                            if(priceItem.type == 10){
                                this.tenPrice = priceItem.price //10集批量购买价格--优惠后

                                this.tenOldPrice = this.NumberMul(this.section.course.coursePrice,10) //10集批量购买价格--原价
                            }
                            if(priceItem.type == 20){
                                this.twityPrice = priceItem.price //20集批量购买价格--优惠后

                                this.twityOldPrice = this.NumberMul(this.section.course.coursePrice,20)  //20集批量购买价格--原价
                            }
                            if(priceItem.type == 30){
                                this.thirtyPrice = priceItem.price //30集批量购买价格--优惠后

                                this.thirtyOldPrice = this.NumberMul(this.section.course.coursePrice,30)  //30集批量购买价格--原价
                            }
                        })
                    }

                    //增加访问量
                    this.upViewParam.id = this.section.id
                    this.upViewParam.previewTimes = this.section.previewTimes + 1
                    this.upViewParam.sectionThumbnail = this.section.sectionThumbnail
                    filmApi.updateSec(this.upViewParam).then(re =>{

                    })
                })
            },

            reloadCC(){
                // 移除组件
                this.isCCReload = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                this.$nextTick(() => {
                    this.isCCReload = true
                })
            },

            reloadScore(){
                // 移除组件
                this.isReloadScore = false
                // 在组件移除后，重新渲染组件
                // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
                this.$nextTick(() => {
                    this.isReloadScore = true
                })
            },

            //切换 全部/我的 剧集列表
            changeShowList(showType){
                this.showType = showType
                this.showPage = this.selectTitlePager(showType)
            },

            selectHeji () {
                this.hejiDialog = true
            },

            //拆分页码  --头部
            selectTitlePager (type) {
                let listLength = this.allSectionList.length
                if(type=='my'){
                    listLength = this.mySectionList.length
                }
                let part = 1
                let forlen = Math.floor(listLength / (part * 10))
                let page = []


                if(type == 'my'){
                    if(listLength <= part * 10){
                        page.push(`1~10`)
                    }else{
                        for(let i = 0;i < forlen;i++){
                            // 中间的循环体
                            page.push(`${parseInt(i * part + '1')}~${(i + 1) * part}0`)
                        }
                        /*if(String(listLength).slice(-1) === '1' && page.length * part * 10 + 1 === listLength){
                          // 最后的长度为 21 || 31 等个位数为1 时 则 只添加 第n集
                          page.push(`第${listLength}集`)
                        }else*/ if (listLength % (10 * part) !== 0){
                            // 否则添加第 n1集 ~ 第 length集
                            page.push(`${forlen * part}1~${(forlen + 1) * part * 10}`)
                        }
                    }
                }else {
                    if(listLength <= part * 10){
                        // 只输出 1 ~ <= 10
                        page.push(`第1~${listLength}集`)
                    }else{
                        for(let i = 0;i < forlen;i++){
                            // 中间的循环体
                            page.push(`第${parseInt(i * part + '1')}~${(i + 1) * part}0集`)
                        }
                        if(String(listLength).slice(-1) === '1' && page.length * part * 10 + 1 === listLength){
                            // 最后的长度为 21 || 31 等个位数为1 时 则 只添加 第n集
                            page.push(`第${listLength}集`)
                        }else if (listLength % (10 * part) !== 0){
                            // 否则添加第 n1集 ~ 第 length集
                            page.push(`第${forlen * part}1~${listLength}集`)
                        }
                    }
                }

                return page
            },
            //选择 分页 --头部
            selectTitlePage (index) {
                console.log("selectTitlePage=-=============",index)
                this.currentPartAllIndex = index
            },
            //选择 分页 --头部
            selectTitleMyPage (index) {
                console.log("selectTitleMyPage=-=============",index)
                this.currentPartMyIndex = index
            },


            //跳转top 并播放
            toTopAndPlay(){
                this.toTop()

                this.$refs.ccVideo.doPlay();
            },
            buyOne(section){
                let sectionId = section.id
                let allowSingleBuy = section.allowSingleBuy
                if(this.isLogin){
                    if(allowSingleBuy){
                        this.$message.error('本集目前只提供专辑购买');
                    }else {
                        this.orderList = []
                        this.setCookie('payVcId',0)
                        this.orderList.push(sectionId);
                        this.beforePay()
                    }

                }else {
                    this.toLog()
                }
            },
            buyHeji(){
                if(this.isLogin){
                    this.beforePay()
                }else {
                    this.toLog()
                }
            },
            toPay(){
                if(this.isLogin){
                    this.orderList = []
                    this.setCookie('payVcId',0)
                    this.allSectionList.forEach(all =>{
                        this.userCheckList.forEach(check =>{
                            if(check == all.sectionName){
                                this.orderList.push(all.id);
                            }
                        })
                    })
                    this.seqZeroSectionList.forEach(all =>{
                        this.userCheckList.forEach(check =>{
                            if(check == all.sectionName){
                                this.orderList.push(all.id);
                            }
                        })
                    })

                    this.beforePay()

                }else {
                    this.$message.error('请登录购买');
                }
            },
            getCookie(key) {
                let cookies = document.cookie.split(';')
                for (let cookie of cookies) {
                    let c = cookie.trim()
                    if (c.indexOf(key + '=') !== -1) {
                        return c.slice(key.length + 1, c.length)
                    }
                }
                return ''
            },
            setCookie(key, value) {
                document.cookie = key + "=" + value  //不设置过期时间，默认为关闭浏览器后清除（关闭标签页不清除）
            },
            delCookie(name){
                var exp = new Date();
                exp.setTime(exp.getTime() - 1);
                var cval=this.getCookie(name);
                if(cval!=null){
                    document.cookie= name + "="+cval+";expires="+exp.toGMTString();
                }
            },

            //1 判断输入分享码 2 跳过分享码
            buyForShare(type){
                if(type == 2){
                    this.iptShareCode = false
                    this.doPay()
                }else{

                    if(!this.inputShareCode){
                        this.$message.error("分享码错误")
                        this.inputShareCode=''
                        return false
                    }
                    const formDataCode = new FormData() // 创建form对象
                    formDataCode.append('invitationCode', this.inputShareCode)// 通过append向form对象添加数据
                    userInfoApi.selectByInvitationCode(formDataCode).then(re => {
                        if(re.code == 1){
                            this.shareCode=re.response.invitationCode
                            this.shareCodeUserId=re.response.userId
                            this.doPay()
                        }else{
                            this.$message.error("分享码错误")
                            this.inputShareCode=''
                        }
                    })
                }
            },

            beforePay(){
                //传入分享码合格
                /*if(this.shareCode){
                  this.doPay()
                }else {
                  //再次输入分享码
                  this.iptShareCode = true
                }*/

                this.doPay()
            },
            doPay(){
                // selectByInvitationCode

                //分享码折扣 2021.1.13 功能下线
                /*if(this.shareCode){
                  this.setCookie('payShareCode',this.shareCode)
                  this.setCookie('payShareCodeUserId',this.shareCodeUserId)
                  //console.log("has shareCode")
                }else {
                  //再次输入分享码
                  //console.log("has not shareCode")

                  this.delCookie('payShareCode')
                  this.delCookie('payShareCodeUserId')
                }*/



                this.setCookie('paySectionId',this.section.id)
                this.setCookie('payIds',this.orderList)
                this.setCookie('payCId',this.section.courseId)



                setTimeout(() =>{
                    this.$router.push({
                        name: '/sectionpay',
                        params: {
                            //ids: this.orderList,cId:this.section.courseId
                        }
                    })
                },1000)
            },
            toPlay(type,sectionId){
                if(type == 1){
                    this.$message.error('请登录')
                    return false
                }else if(type == 2){
                    if(this.isLogin){
                        this.$message.error('暂未购买')
                    }else {
                        this.$message.error('请登录')
                    }
                    return false
                }else if(type == 3){
                    this.$message.error('预售中')
                    return false
                }else {

                }

            },


            setHtml(item){
                //document.title = item.sectionName+"——人人动画网【官网】"
                let thiss = this
                let html =""
                //contentForm:"1",//1为视频；9为引用视频；10为通用代码
                html = '<iframe id="cciframe_'+item.videoId+'" src="https://p.bokecc.com/playhtml.bo?vid='+item.videoId+'&siteid=9D23FB9C216EB7C0&autoStart=true&playerid=2B0B9D320AC51E5F&playertype=1&newversion=true" allowfullscreen="true" frameborder="0" ></iframe>'
                thiss.videoHtml = html
                window.scrollTo({
                    top:0,
                    behavior: "smooth"
                })
                thiss.isShow = true
            },

            setCCDIV(item){
                //document.title = item.sectionName+"——人人动画网【官网】"
                console.log("item----------",item)
                if(item.videoId){
                    this.ccsrc = "https://union.bokecc.com/player?vid="+item.videoId+
                        "&siteid=9D23FB9C216EB7C0&autoStart="+this.isAutoStart+"" +
                        "&playerid=0581667E1FFB8B2A&playertype=1&width=100%&height=100%&playertype=1&newversion=true"
                }
                // 片花使用免密账号视频 ，使用免密账号和播放器 3215A0D31F92FF6C / 6CBFA16FE71DFF2A
                if(item.movieClipsId){
                    this.clipsCCSrc = "https://union.bokecc.com/player?vid="+item.movieClipsId+
                        "&siteid=3215A0D31F92FF6C&autoStart="+this.isAutoStart+
                        "&playerid=6CBFA16FE71DFF2A&playertype=1&width=100%&height=100%&playertype=1&newversion=true"
                }else{
                    this.clipsCCSrc =''
                }

                // console.log('this.ccsrc===================',this.ccsrc)
                this.ccPic = item.sectionThumbnail

                this.reloadCC();
                /*window.scrollTo({
                    top:0,
                    behavior: "smooth"
                })*/
            },



            //跳转登录页面
            toLog(){
                this.$router.push({
                    path:'/login?callback=' + window.location.href,
                })

            } ,



            //选择 购买弹窗 类型
            selectJiEvent (part) {
                if(this.isLogin){
                    this.part = part
                    this.currentPartIndex = 0
                    this.userCheckList = []
                    this.checkAll = false
                    this.isIndeterminate = false
                    this.selectDialog = true
                }else {
                    this.toLog()
                }

            },
            //选择 分页 --剧集
            selectPage (index) {
                this.currentPartIndex = index
                this.handleCheckedCitiesChange()
            },

            handleCheckAllChange(val,e) {

                if(this.userCheckList.length + this.filmList.length > 10 * this.part && val){
                    this.$message.error("不能超出可选上限")
                    return false
                }

                let nobuy = this.filmList.filter(item => {
                    return item.buy !== true && item.isPay !== 1
                }).map(item => {
                    return item.sectionName
                })

                if(val){
                    this.userCheckList = [...new Set([...this.userCheckList, ...nobuy])]
                }else{
                    this.userCheckList = [...new Set([...this.userCheckList, ...nobuy])].filter(item => !nobuy.includes(item))
                }
                this.isIndeterminate = false
            },
            handleCheckedCitiesChange() {
                // userCheckList.length == part
                let same = this.filmList.map(item => item.sectionName).filter(item => this.userCheckList.includes(item))
                let nobuy = this.filmList.filter(item => {
                    return item.buy !== true && item.isPay !== 1
                }).map(item => {
                    return item.sectionName
                })



                if (same.length === nobuy.length) {
                    this.checkAll = true
                    this.isIndeterminate = false
                }else if (same.length === 0){
                    this.checkAll = false
                    this.isIndeterminate = false
                }else{
                    this.checkAll = false
                    this.isIndeterminate = true
                }
            },
            delFilm (index) {
                this.userCheckList.splice(index, 1)
                this.handleCheckedCitiesChange()
            },
            emptyFilm () {
                this.userCheckList = []
                this.handleCheckedCitiesChange()
            },




            nextSection(){
                let length = this.mySectionList.length
                let nowId = this.section.id
                let nowIndex = -1;
                this.mySectionList.forEach((item,index) =>{
                    if(nowId == item.id){
                        nowIndex = index+1
                    }
                })
                if(nowIndex < length){
                    this.selectSec(this.mySectionList[nowIndex].id,true)
                }
            }
        }
    }
</script>

<style>
    .yh-popo{
        padding: 0;
        background: none;
        border: none;
        box-shadow: none;
    }
</style>
<style scoped lang="less">
    @import "./filmdetail.less";
</style>
